
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { CodesPricesRequest, CodePricesResponse, LinesRequest, InvoiceLine } from '@jms/model';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class PricingService {

    private readonly codeAPI = 'api/codes/';

    constructor(
        private http: HttpClient,
    ) { }

    public getCodePrice(request: CodesPricesRequest): Observable<CodePricesResponse[]> {

        return this.http
            .post<CodePricesResponse[]>(`${this.codeAPI}prices`, request)
            .pipe(
                map(x => x),
                catchError(httpError => {
                    return of([]);
                })
            );
    }

    public getLinesPrice(request: LinesRequest): Observable<InvoiceLine[]> {

        return this.http
            .post<InvoiceLine[]>(`${this.codeAPI}line/prices`, request)
            .pipe(
                map(x => x),
                catchError(httpError => {
                    return of([]);
                })
            );
    }
}